import './App.css';
import { About, Home, Contact, Inventory, FAQs } from './containers';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { InventoryModalRoute } from './components';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppRoutes />
      </Router>
    </HelmetProvider>
  );
}

function AppRoutes() {
  const location = useLocation();
  const previousLocation = location.state?.previousLocation;

  // If the user navigates directly to an inventory item,
  // render the main routes as if we're on `/inventory` so the
  // inventory page (latest items) appears behind the modal.
  const directItemMatch = location.pathname.match(/^\/shop\/([^/]+)\/([^/]+)\/([^/]+)/);
  const isLegacyDirectItemRoute = /^\/inventory\/item\/(.+)/.test(location.pathname);
  const backgroundPath = directItemMatch ? `/shop/${directItemMatch[1]}/${directItemMatch[2]}` : '/inventory';
  const backgroundLocation = previousLocation || ((directItemMatch || isLegacyDirectItemRoute) ? { ...location, pathname: backgroundPath } : location);

  return (
    <div>
      <Routes location={backgroundLocation}>
        <Route path="/" element={<Home />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/inventory/:category/:subcategory" element={<Inventory />} />
        <Route path="/shop/:category/:subcategory" element={<Inventory />} />
        <Route path="/about" element={<About />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Routes>
        <Route path="/inventory/item/:id" element={<InventoryModalRoute />} />
        <Route path="/shop/:category/:subcategory/:itemSlug" element={<InventoryModalRoute />} />
      </Routes>
    </div>

  );
}

export default App;
